module.exports = __webpack_public_path__ + "static/img/labour-2.e797657.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/labour-2.png
// module id = MyNw
// module chunks = 1